<template>
  <div class="aboutUsBox">
    <nav-bar :title="$t('关于我们')" bg-color="#446D7A" left-arrow left-color="#fff" title-color="#fff"/>
    <div class="text" v-html="text"/>
  </div>
</template>
<script>
export default {
  data() {
    return {
      text: "",
    }
  },
  computed: {},
  watch: {},
  methods: {
    agreement() {
      this.$get({
          url: `/agreement?type=3`,
          loading: !this.local.get('mine_aboutUs'), // 如果有缓存就不显示loading
          success: (res) => {
            this.text = res.data.content
            // 更新缓存
            this.local.set('mine_aboutUs', JSON.stringify(res.data.content))
          },
          tip: () => {
          }
        })
    },
  },
  created() {
      // 检查缓存
      const cachedAboutUs = this.local.get('mine_aboutUs')
      if (cachedAboutUs) {
        this.text = JSON.parse(cachedAboutUs)
      }
      this.agreement()
    },
  mounted() {
  },
}
</script>

<style lang="less" scoped>
.aboutUsBox {
  width: 100%;
  min-height: 100vh;
  background-color: #446D7A;
  padding: 20px 15px;

  .text {
    color: #ffffff;
  }
}
</style>
